/** Peer public directories share one title scale, independent of their layout. */
export function DirectoryHeading({ children }: { children: string }) {
  return (
    <h1 className="nxt text-[2rem] leading-tight text-pretty uppercase [overflow-wrap:anywhere] adm:text-5xl">
      {children}
    </h1>
  );
}
